/** * 左边菜单 */
<template>
  <div class="left-nav">
    <div class="left-box">
      <div class="left-menu" v-loading="menuLoading">
        <div
          v-for="(item, index) in allmenu"
          :key="index"
          :class="[
            'menu-parent',
            activeMenu === item.path ? 'is-active' : '',
            isFlatParent(item) ? 'is-flat' : '',
            expandedMap[item.path] ? 'is-expanded' : ''
          ]"
        >
          <div class="menu-parent__title" @click="handleParentClick(item)">
            <img class="menu-icon" :src="resolveMenuIcon(item)" alt="" />
            <span>{{ item.meta.title }}</span>
            <i
              v-if="
                !isFlatParent(item) && item.children && item.children.length
              "
              class="el-icon-arrow-down menu-arrow"
            ></i>
          </div>
          <template v-if="!isFlatParent(item)">
            <div
              :class="[
                'menu-item',
                isActiveMenu(item, menu) ? 'active-menu' : ''
              ]"
              v-for="(menu, key) in item.children"
              :key="key"
              v-show="expandedMap[item.path] || activeMenu === item.path"
              @click.stop="routerChange(item, menu)"
            >
              {{ menu.meta.title }}
            </div>
          </template>
        </div>
      </div>
      <div class="left-footer">
        <img class="left-footer__deco" :src="footerDecoImg" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { fetchUserMenus } from "@/utils/dynamicMenu";
import { loadUserPermissions } from "@/utils/permission";
import { getToken } from "@/utils/token";
import footerDecoImg from "@/assets/img/home/welcome-monitor.png";
const MENU_ICON_MAP = {
  "/home": {
    normal: require("@/assets/img/menu/home.png"),
    active: require("@/assets/img/menu/home-active.png")
  },
  "/course": {
    normal: require("@/assets/img/menu/course.png"),
    active: require("@/assets/img/menu/course-active.png")
  },
  "/question": {
    normal: require("@/assets/img/menu/question.png"),
    active: require("@/assets/img/menu/question-active.png")
  },
  "/students": {
    normal: require("@/assets/img/menu/student.png"),
    active: require("@/assets/img/menu/student-active.png")
  },
  "/message": {
    normal: require("@/assets/img/menu/message.png"),
    active: require("@/assets/img/menu/message-active.png")
  },
  "/system": {
    normal: require("@/assets/img/menu/system.png"),
    active: require("@/assets/img/menu/system-active.png")
  },
  "/teacher": {
    normal: require("@/assets/img/menu/teacher.png"),
    active: require("@/assets/img/menu/teacher-active.png")
  },
  "/review": {
    normal: require("@/assets/img/menu/review.png"),
    active: require("@/assets/img/menu/review-active.png")
  },
  "/banner": {
    normal: require("@/assets/img/menu/banner.png"),
    active: require("@/assets/img/menu/banner-active.png")
  },
  "/activity": {
    normal: require("@/assets/img/menu/activity.png"),
    active: require("@/assets/img/menu/activity-active.png")
  },
  "/knowledge": {
    normal: require("@/assets/img/menu/Knowledge.png"),
    active: require("@/assets/img/menu/Knowledge-active.png")
  },
  "/Knowledge": {
    normal: require("@/assets/img/menu/Knowledge.png"),
    active: require("@/assets/img/menu/Knowledge-active.png")
  },

  "/course-category": {
    normal: require("@/assets/img/menu/course-category.png"),
    active: require("@/assets/img/menu/course-category-active.png")
  },

  "/news": {
    normal: require("@/assets/img/menu/news.png"),
    active: require("@/assets/img/menu/news-active.png")
  },
  "/News": {
    normal: require("@/assets/img/menu/banner.png"),
    active: require("@/assets/img/menu/news-active.png")
  }
};

export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      allmenu: [],
      menuLoading: false,
      expandedMap: {},
      footerDecoImg
    };
  },
  computed: {
    activeMenu() {
      return "/" + this.$route.path.split("/")[1];
    }
  },
  methods: {
    resolveMenuIcon(item) {
      const path = item.path || "";
      const icons = MENU_ICON_MAP[path] || MENU_ICON_MAP["/home"];
      const isActive = this.activeMenu === path;
      return isActive ? icons.active : icons.normal;
    },
    isFlatParent(item) {
      const children = (item && item.children) || [];
      return children.length <= 1;
    },
    isActiveMenu(parent, child) {
      const target = child.fullPath || `${parent.path}/${child.path}`;
      if (
        (this.$route.path === "/course/detail" ||
          this.$route.path === "/course/edit") &&
        target === "/course"
      ) {
        return true;
      }
      return (
        this.$route.path === target || this.$route.path.startsWith(target + "/")
      );
    },
    handleParentClick(item) {
      const children = item.children || [];
      if (this.isFlatParent(item)) {
        if (children.length === 1) {
          this.routerChange(item, children[0]);
        } else if (item.path) {
          this.$router.push(item.path);
        }
        return;
      }
      this.$set(this.expandedMap, item.path, !this.expandedMap[item.path]);
    },
    routerChange(menu, children) {
      const path = children.fullPath || `${menu.path}/${children.path}`;
      this.$router.push(path);
    },
    async refreshMenu() {
      const token = getToken();
      if (!token) {
        this.allmenu = [];
        return;
      }

      this.menuLoading = true;
      try {
        await loadUserPermissions(this);
        this.allmenu = await fetchUserMenus({ force: true });
        const map = {};
        (this.allmenu || []).forEach(item => {
          if (!this.isFlatParent(item) && this.activeMenu === item.path) {
            map[item.path] = true;
          }
        });
        this.expandedMap = map;
      } catch (e) {
        this.allmenu = [];
      } finally {
        this.menuLoading = false;
      }
    }
  },
  created() {
    this.refreshMenu();
    this.$root.Bus.$on("toggle", value => {
      this.collapsed = !value;
    });
    this.$root.Bus.$on("user-info-updated", this.refreshMenu);
    this.$root.Bus.$on("menu-updated", this.refreshMenu);
  },
  beforeDestroy() {
    this.$root.Bus.$off("user-info-updated", this.refreshMenu);
    this.$root.Bus.$off("menu-updated", this.refreshMenu);
  }
};
</script>
<style lang="less">
.left-nav {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f9ff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(28, 104, 255, 0.06);

  .left-box {
    flex: 1;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
  }

  .left-menu {
    .menu-parent {
      color: #64748b;
      font-size: 18px;
      margin-bottom: 6px;
      cursor: pointer;
      margin-bottom: 18px;
      font-weight: 600;

      &__title {
        display: flex;
        align-items: center;
        height: 52px;
        padding: 0 12px;
        border-radius: 10px;
        line-height: 52px;
        transition: all 0.2s;

        &:hover {
          background: rgba(28, 104, 255, 0.05);
        }
      }

      img.menu-icon {
        width: 32px;
        height: 32px;
        margin-right: 12px;
        vertical-align: middle;
        flex-shrink: 0;
        object-fit: contain;
        border-radius: 6px;
      }

      .menu-fallback-icon {
        margin-right: 12px;
        font-size: 18px;
        color: #64748b;
      }

      .menu-arrow {
        margin-left: auto;
        font-size: 14px;
        color: #64748b;
        transition: transform 0.2s;
      }

      &.is-expanded .menu-arrow {
        transform: rotate(180deg);
      }

      .menu-item {
        color: #64748b;
        font-size: 16px;
        height: 36px;
        line-height: 36px;
        padding-left: 42px;
        border-radius: 8px;
        margin-top: 4px;
        transition: all 0.2s;

        &:hover {
          color: #3861ca;
          background: rgba(28, 104, 255, 0.06);
        }
      }

      .active-menu {
        color: #3861ca;
        background: linear-gradient(
          153deg,
          rgba(99, 152, 241, 0.2) 0%,
          rgba(92, 99, 246, 0.12) 100%
        );

        &:hover {
          color: #3861ca;
          background: linear-gradient(
            153deg,
            rgba(99, 152, 241, 0.2) 0%,
            rgba(92, 99, 246, 0.12) 100%
          );
        }
      }

      /* 单子菜单：整行高亮 */
      &.is-flat.is-active {
        .menu-parent__title {
          color: #3861ca;
          background: rgba(28, 104, 255, 0.1);
          font-weight: 600;
        }
        img.menu-icon {
          opacity: 1;
        }
        .menu-fallback-icon {
          color: #3861ca;
        }
      }
    }

    .is-active:not(.is-flat) {
      color: #3861ca;
      > .menu-parent__title {
        color: #3861ca;
      }

      img.menu-icon {
        opacity: 1;
      }

      .menu-fallback-icon {
        color: #3861ca;
      }
    }
  }

  .left-footer {
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 12px 8px 0;

    &__deco {
      width: 100%;
      max-width: 180px;
      height: auto;
      margin-bottom: 20px;
      display: block;
      object-fit: contain;
      pointer-events: none;
      user-select: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/leftnav.vue